export default {
  init() {
    // Check if we're on the vouchers/store credit page using body class
    // This works regardless of language-specific URL slugs
    if (document.body.classList.contains('woocommerce-account') && 
        document.querySelector('.woocommerce-MyAccount-content--vouchers, [data-endpoint="vouchers"]')) {
      import('@lottiefiles/lottie-player');
    }
  },
  finalize() {
  },
};
